import { Component, Inject, NgZone } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { isObservable } from 'rxjs';
import { DialogData } from '../../../../domain/common.model';

@Component({
    selector: 'app-dialog',
    templateUrl: './dialog.component.html'
})
export class DialogComponent {
    constructor(
        private dialogRef: MatDialogRef<DialogComponent>,
        private ngZone: NgZone,
        @Inject(MAT_DIALOG_DATA) public data: DialogData) {
    }

    onConfirm() {
        this.runAndClose(this.data.onConfirm);
    }

    onDismiss() {
        this.runAndClose(this.data.onDismiss);
    }

    runAndClose(method) {
        if (typeof (method) === 'function') {
            const result = method();
            if (isObservable(result)) {
                result.subscribe(
                    () => this.close(),
                    () => this.close()
                );
                return;
            }
        }
        this.close();
    }

    close() {
        this.ngZone.run(() => this.dialogRef.close());
    }
}
